import React from "react";

import { SceletonStyled } from "./sceleton.styled";

export default function skeleton() {
  return <SceletonStyled />;
}
